// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","brand":"Navbar_brand__wAuKA","links_list":"Navbar_links_list__lwWOI","active":"Navbar_active__em+eI"};